import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getFaqsListSaga = createAction(
  "GET_FAQS",
  ({ payload, params }: SagaActionParams<Type.FaqsDto[]>) => ({
    payload,
    url: "/api/admin/adminfaqs" + (params ? params : ""),
  })
);
export const getFaqsDetailsSaga = createAction(
  "GET_FAQS_DETAILS",
  ({ payload, id }: SagaActionParams<Type.FaqsDetailDto>) => ({
    payload,
    url: "/api/admin/adminfaqs/" + id,
  })
);
export const createFaqsSaga = createAction(
  "CREATE_FAQS",
  ({ payload, body }: SagaActionParams<Type.FaqsDto>) => ({
    payload,
    url: "/api/admin/adminfaqs",
    body,
  })
);
export const updateFaqsSaga = createAction(
  "UPDATE_FAQS",
  ({ payload, id, body }: SagaActionParams<Type.FaqsDto>) => ({
    payload,
    url: "/api/admin/adminfaqs/" + id,
    body,
  })
);
export const deleteFaqsSaga = createAction(
  "DELETE_FAQS",
  ({ payload, id }: SagaActionParams<Type.FaqsDto>) => ({
    payload,
    url: "/api/admin/adminfaqs/" + id,
  })
);

const faqsSaga = [
  takeLatest<any>(
    getFaqsListSaga.toString(),
    (payload: SagaGenericParams<Type.FaqsDto[]>) =>
      getSaga<Type.FaqsDto[]>(payload)
  ),
  takeLatest<any>(
    getFaqsDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.FaqsDetailDto>) =>
      getSaga<Type.FaqsDetailDto>(payload)
  ),
  takeLatest<any>(
    createFaqsSaga.toString(),
    (payload: SagaGenericParams<Type.FaqsDto>) =>
      postSaga<Type.FaqsDto>(payload)
  ),
  takeLatest<any>(
    updateFaqsSaga.toString(),
    (payload: SagaGenericParams<Type.FaqsDto>) => putSaga<Type.FaqsDto>(payload)
  ),
  takeLatest<any>(
    deleteFaqsSaga.toString(),
    (payload: SagaGenericParams<any>) => deleteSaga<Type.FaqsDto>(payload)
  ),
];

export default faqsSaga;
